/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import Map from '../../components/map';
import SidePanel from '../../components/SidePanel';
import MapToolbar from '../../components/MapToolbar';
import ActionType from '../../store/ActionType';
import { GlobalContext } from '../../store/Store';
import Api from '../../apis/meshApi';
import PollingWrapper from '../../components/app/Polling/PollingWrapper';
import { TPanelId } from '../../components/SidePanel/SidePanel';
import Grid from '@mui/material/Grid';

interface IProps {
  initialSidePanelTab: TPanelId;
}

const sidebarStyle = css`
 width: 60px;
`;

export default function MapPage(props: IProps) {
  const { initialSidePanelTab } = props;
  const [selectedLayer, setSelectedLayer] = useState(0);
  const [sidePanelOpen, setSidePanelOpen] = useState(false);
  const [, globalDispatch] = useContext(GlobalContext);

  PollingWrapper();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  const query = useQuery();

  const projectId = query.get('projectID');

  useEffect(() => {
    async function fetchProjectAndPath(id: string) {
      try {
        const projectResponse = await Api.getProject(id);
        const pathResponse = await Api.getProjectPath(id);
        if (projectResponse && projectResponse.data) {
          globalDispatch({
            type: ActionType.SET_CURRENT_PROJECT_AND_PATH,
            data: {
              project: projectResponse.data,
              path: pathResponse && pathResponse.data ? pathResponse.data : [],
            },
          });
        }
      } catch (e) {
        console.log(e.message || 'Unexpected error');
      }
    }
    const getProjectAndPath = async () => {
      await fetchProjectAndPath(projectId);
    };
    if (projectId){
      getProjectAndPath();
    } 
  }, [projectId]);

  

  const onLayerChanged = (layer: number) => {
    setSelectedLayer(layer);
  };

  const onSidePanelOpen = (active: boolean) => {
    setSidePanelOpen(active);
  };

  return (
    <div className="MapPage" id={sidePanelOpen ? 'activeSidePanel' : ''}> 
      <Grid item css={sidebarStyle}>
        <SidePanel
          onLayerChanged={onLayerChanged}
          onSidePanelOpen={onSidePanelOpen}
          initialSidePanelTab={initialSidePanelTab}
        />
      </Grid>

      <MapToolbar />

      <Grid item>
        <Map selectedLayer={selectedLayer} />
      </Grid>
    </div>
  );
}
